import React, { useState } from "react";
import { Row, Col, Checkbox } from "antd";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import { DatePickerItem } from "../../../components/forms/FormItems";
import { SettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { EmployeesSelect } from "../../../components/forms/AutoCompleteFormItem";
import { useIntl } from "react-intl";

const Reference = (props) => {
  const { onAddReference, addReference, values, branchId, changeReferrerType } =
    props;
  const [referrerType, setReferrerType] = useState(null);

  const intl = useIntl();
  const onChange = (e) => {
    onAddReference(e.target.checked);
  };

  const filterItems = (data) => {
    const filtered =
      values && values?.references?.referrer_id
        ? data.filter(
            (i) =>
              i.referrer_id === values.references.referrer_id &&
              i.branches.includes(+branchId)
          )
        : [];

    return filtered;
  };

  const filterReferrers = (items) => {
    const selected = items.find(
      (i) => i.id === values?.references?.referrer_id
    );
    setReferrerType(selected?.referrer_type);
    changeReferrerType(selected?.referrer_type);
    return items;
  };

  return (
    <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
      <Checkbox
        onChange={onChange}
        checked={addReference}
        style={{ padding: "10px 0" }}
      >
        {intl.formatMessage({
          id: "app.opportunities.add_reference",
        })}
      </Checkbox>
      <ChildrenAnimationWrapper>
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={1}>
                  <DatePickerItem
                    name="references.reference_time"
                    category="patient"
                    required={addReference}
                    format={"L"}
                    disabled={!addReference}
                  />
                </AnimationChildWrapper>
              </div>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={2}>
                  <SettingsDataSelect
                    name={"references.referrer_id"}
                    category={"patient"}
                    required={addReference}
                    settingsdataName={"system_tables/referrer"}
                    disabled={!addReference}
                    filterItems={filterReferrers}
                  />
                </AnimationChildWrapper>
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={3}>
                  {referrerType === "employees" ? (
                    <EmployeesSelect
                      name={"references.employee_id"}
                      category={"patient"}
                      required={true}
                      type={"list"}
                    />
                  ) : (
                    <SettingsDataSelect
                      name={"references.sub_referrer_id"}
                      category={"patient"}
                      required={addReference}
                      settingsdataName={"system_tables/sub_referrer"}
                      filterItems={filterItems}
                      disabled={!addReference}
                    />
                  )}
                </AnimationChildWrapper>
              </div>
              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </ChildrenAnimationWrapper>
    </div>
  );
};

export default Reference;
